import { UserStation } from './../../models/UserStation';
import { User } from '../../models/User';
import { UserActionTypes } from '../actions/users';
import { ConfirmUser } from '../../models/ConfirmUser';

export interface UserState {
  users: User[];
  userDetails?: User;
  userStations: UserStation[];
  confirmUsers: ConfirmUser[];
}

const initialState: UserState = {
  users: [],
  userDetails: undefined,
  userStations: [],
  confirmUsers: [],
};

export default (state = initialState, action: UserActionTypes) => {
  switch (action.type) {
    case 'GET_USERS':
      return {
        ...state,
        users: action.payload.users,
      };
    case 'GET_USER_DETAILS':
      return {
        ...state,
        userDetails: action.payload.userDetails,
      };
    case 'GET_USER_STATIONS':
      return {
        ...state,
        userStations: action.payload.userStations,
      };
    case 'GET_CONFIRM_USERS':
      return {
        ...state,
        confirmUsers: action.payload.confirmUsers,
      };
    default:
      return state;
  }
};
